/** 子中心 URL 路径段枚举 */
export const SUB_CENTER = {
  /** 算力中心：当前无独立 URL 前缀，默认主视图视为算力中心 */
  COMPUTE: 'compute-center',
  /** 资源中心：仅数据中心展示 */
  RESOURCE: 'resource-center',
  /** 费用中心：仅租户空间展示 */
  CHARGE: 'charge-center',
  OPS: 'ops-center',
  AI: 'ai-center',
  APP: 'app-center',
  BIZ: 'biz-center',
} as const;

export type SubCenterKey = (typeof SUB_CENTER)[keyof typeof SUB_CENTER];

/** 所有子中心路径段值列表，供路径匹配等场景使用 */
export const SUB_CENTER_VALUES = Object.values(SUB_CENTER) as SubCenterKey[];
